module.exports = __webpack_public_path__ + "static/intertec_screen_2-0ee5285a5122db62adf8d6def8926b91.jpg";